import { render, staticRenderFns } from "./Opportunities.vue?vue&type=template&id=6c955912&scoped=true"
import script from "./Opportunities.vue?vue&type=script&lang=ts"
export * from "./Opportunities.vue?vue&type=script&lang=ts"
import style0 from "./Opportunities.vue?vue&type=style&index=0&id=6c955912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c955912",
  null
  
)

export default component.exports